import lrBMapPanel from './_src/lrBMapPanel.vue'

lrBMapPanel.install = function(Vue) {
  Vue.component(lrBMapPanel.name, lrBMapPanel)
}

export default lrBMapPanel